import React from "react";
import Header from "./Header.js";
export default function MedicinePage() {
  return (
    <div className="container my-4">
       <Header/>
     
    </div>
  );
}
